import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Star } from "lucide-react";
import { displayUrl, CATEGORIES } from "./imageUrl";

export const EditImageDialog = ({ image, isHero, onClose, onSave, onSetHero }) => {
  const [form, setForm] = useState({ alt: "", category: "portraits" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (image) setForm({ alt: image.alt || "", category: image.category || "portraits" });
  }, [image]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await onSave(image.id, form);
    setSaving(false);
  };

  return (
    <Dialog open={!!image} onOpenChange={(open) => !open && onClose()}>
      <DialogContent data-testid="gallery-edit-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-charcoal">Edit Photo</DialogTitle>
          <DialogDescription className="font-body text-stone-grey">Update the caption or move it to another category.</DialogDescription>
        </DialogHeader>
        {image && (
          <form onSubmit={submit} className="space-y-4">
            <div className="rounded-lg overflow-hidden bg-sand/30">
              <img src={displayUrl(image.url)} alt={image.alt} className="w-full max-h-56 object-contain" />
            </div>
            <div>
              <Label className="font-body text-sm text-stone-grey mb-2 block">Caption / Alt Text</Label>
              <Input data-testid="gallery-edit-alt-input" value={form.alt} onChange={(e) => setForm({ ...form, alt: e.target.value })} required className="form-input" />
            </div>
            <div>
              <Label className="font-body text-sm text-stone-grey mb-2 block">Category</Label>
              <select data-testid="gallery-edit-category-select" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="form-input w-full">
                {CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
              </select>
            </div>
            <div className="flex flex-wrap gap-2 pt-2">
              <Button type="submit" className="btn-primary" disabled={saving} data-testid="gallery-edit-save-btn">Save Changes</Button>
              <Button type="button" variant="outline" onClick={onClose} data-testid="gallery-edit-cancel-btn">Cancel</Button>
              <Button type="button" variant="outline" className="ml-auto" disabled={isHero} onClick={() => onSetHero(image)} data-testid="gallery-edit-set-hero-btn">
                <Star className="w-4 h-4 mr-2" /> {isHero ? "Current Hero" : "Use as Home Hero"}
              </Button>
            </div>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
